export default function matchMediaOr(match: string, srrDefault = false) {
  if (typeof window === 'undefined') return srrDefault
  const mq = window.matchMedia(match)
  return mq.matches
}
